import {
    GET_BOOKING_FORM_FAIL,
    GET_BOOKING_FORM_REQUEST,
    GET_BOOKING_FORM_SUCCESS, UPDATE_BOOKING_FORM_DATA
} from "../constants/bookingFormConstants";

export const getBookingFormReducer = (state = {booking: null, form: null, loading: false}, action) => {
    switch (action.type) {
        case GET_BOOKING_FORM_REQUEST:
            return {booking: null, form: null, loading: true};
        case GET_BOOKING_FORM_SUCCESS:
            return {loading: false, ...action.payload};
        case GET_BOOKING_FORM_FAIL:
            return {loading: false, error: action.payload};
        case UPDATE_BOOKING_FORM_DATA:
            return {...state, form: action.payload};
        default:
            return state;
    }
};